// document.querySelectorAll('.image-zoom-wrapper').forEach(wrapper => {
//     const image = wrapper.querySelector('.zoomable-image');

//     wrapper.addEventListener('mousemove', (e) => {
//         const rect = wrapper.getBoundingClientRect();
//         const x = (e.clientX - rect.left) / rect.width * 100;
//         const y = (e.clientY - rect.top) / rect.height * 100;
//         image.style.transformOrigin = `${x}% ${y}%`;
//         image.style.transform = 'scale(1.5)';
//     });

//     wrapper.addEventListener('mouseleave', () => {
//         image.style.transformOrigin = 'center center';
//         image.style.transform = 'scale(1)';
//     });
// });



 // Selecting elements
 const menuBtn = document.getElementById('menu-btn');
 const closeBtn = document.getElementById('close-btn');
 const sidebar = document.getElementById('sidebar');
 const overlay = document.getElementById('overlay');
 const body = document.body;

 // Open sidebar
 menuBtn.addEventListener('click', () => {
   sidebar.classList.add('open');
   overlay.classList.add('show');
   body.classList.add('menu-open');
 });

 // Close sidebar
 const closeSidebar = () => {
   sidebar.classList.remove('open');
   overlay.classList.remove('show');
   body.classList.remove('menu-open');
 };

 closeBtn.addEventListener('click', closeSidebar);
 overlay.addEventListener('click', closeSidebar);
 document.addEventListener('keydown', (e) => {
   if (e.key === 'Escape') closeSidebar();
 });





 document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.animate');

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible'); // Add animation class
            observer.unobserve(entry.target); // Stop observing after animation
          }
        });
      },
      { threshold: 0.2 } // Trigger when 20% of the element is visible
    );

    sections.forEach(section => {
      observer.observe(section);
    });
  });


  document.addEventListener('DOMContentLoaded', () => {

    const biglogo = document.querySelector('.pageheader .navbar');

    
    
  
    if(biglogo.classList.contains('site-header')){
        const headerHome = document.querySelector('.site-header');
        window.addEventListener('scroll', () => {
            if (window.scrollY > 50) {
                headerHome.classList.add('shrink'); // Apply the "shrink" class when scrolling down
            } else {
                headerHome.classList.remove('shrink'); // Remove the "shrink" class when at the top
            }
        });
    } else if (biglogo.classList.contains('othersHeader')){
        window.addEventListener('scroll', () => {
            const header = document.querySelector('.othersHeader');
            if (window.scrollY > 50) {
              header.classList.add('comonHeader'); 
            } else {
              header.classList.remove('comonHeader'); 
            }
          });
    } else {
        window.addEventListener('scroll', () => {
            const header = document.querySelector('.otherInnerpage');
            if (window.scrollY > 50) {
              header.classList.add('innerHeader'); 
            } else {
              header.classList.remove('innerHeader'); 
            }
          });
    }
    

    
  
    
  });


 document.addEventListener("DOMContentLoaded", () => {
    const products = document.querySelectorAll(".prodBoxMens");
    const classes = ["prod1", "prod2", "prod3", "prod4"];
  
    products.forEach((product, index) => {
      // Determine the class to add based on the index
      const classToAdd = classes[index % 4];
      product.classList.add(classToAdd);
    });
  });





